import {
  openContentGeneratorModal,
  contentGeneratorModalSelector,
  showContentGeneratorForm,
} from "./contentGeneratorModal";

// ── Helpers ──

/**
 * Extract the asset URL and type from a .btn-use-as-reference element.
 * Prefer an explicit reference URL (used when a video points to its source
 * image), then fall back to the surrounding gallery asset.
 */
function getAssetFromButton($btn) {
  var $wrapper = $btn.closest(".image-wrapper");
  var assetUrl = $btn.attr("data-reference-url") ||
    ($wrapper.length ? $wrapper.attr("href") : "");
  if (!assetUrl || assetUrl === "javascript:void(0)") return null;

  var assetType = "image";
  if (assetUrl.match(/\.(mp4|webm|mov)(\?|#|$)/i)) assetType = "video";
  else if (assetUrl.match(/\.(mp3|wav|ogg|m4a)(\?|#|$)/i)) assetType = "audio";

  return { url: assetUrl, type: assetType };
}

/**
 * Populate the content-generator modal with a reference asset:
 * select the matching tab, store data, and render the preview.
 */
function populateReferenceInModal(modal, assetUrl, assetType) {
  modal
    .find('.content-generator-nav-item[data-type="' + assetType + '"]')
    .trigger("click");

  modal.data("referenceAssetUrl", assetUrl);
  modal.data("referenceAssetType", assetType);

  showReferenceAssetPreview(modal, assetUrl, assetType);
}

/**
 * Handle a "use as reference" click: extract the asset, then either
 * reset the already-open modal or show it fresh (with a shown.bs.modal
 * callback to populate the reference once visible).
 */
function handleUseAsReferenceClick($btn) {
  var asset = getAssetFromButton($btn);
  if (!asset) return;

  var openedFromFancybox = $btn.closest(".fancybox-container").length > 0;
  var modal = $(contentGeneratorModalSelector);

  if (modal.length && modal.hasClass("show")) {
    // Modal already open (e.g. showing generated results) —
    // reset to form view and populate the reference directly.
    showContentGeneratorForm(modal);

    populateReferenceInModal(modal, asset.url, asset.type);

    // Generated-media results open Fancybox above the already-visible
    // generator modal. Reveal the populated form after selecting a reference.
    if (
      openedFromFancybox &&
      $.fancybox &&
      typeof $.fancybox.close === "function"
    ) {
      $.fancybox.close(true);
    }
  } else {
    // Preserve existing modal params (character context) when opening
    // via "Use as reference", so character_slug / character_id / reason
    // are not lost and the correct credits table is used.
    var existingParams = {};

    if (modal.length) {
      // Modal already in DOM (hidden) — keep its existing params
      try {
        existingParams = JSON.parse(modal.attr("data-params") || "{}");
      } catch (e) {
        existingParams = {};
      }

      // An AJAX-rendered profile modal already owns canonical character
      // context even when it has never been opened through its page trigger.
      // Recover that context before setup overwrites the submit attributes.
      var submitBtn = modal.find(".content-generator-submit").first();
      if (!existingParams.character_slug) {
        existingParams.character_slug = modal.attr("data-character-slug") ||
          submitBtn.attr("data-character-slug") || "";
      }
      if (!existingParams.character_hash) {
        existingParams.character_hash =
          submitBtn.attr("data-character-hash") || "";
      }
      if (!existingParams.character_id) {
        existingParams.character_id = submitBtn.attr("data-character-id") || "";
      }
      if (!existingParams.reason) {
        existingParams.reason = submitBtn.attr("data-reason") || "";
      }
    } else {
      // Modal not yet loaded — try to derive context from the page-level
      // "Generate Media" trigger button (profile / roleplay pages).
      var pageTrigger = $(
        ".btn-content-generator-trigger[data-params]"
      ).first();
      if (pageTrigger.length) {
        try {
          existingParams = JSON.parse(pageTrigger.attr("data-params") || "{}");
        } catch (e) {
          existingParams = {};
        }
      }
    }

    // Wait for the modal to be fully shown (handles both AJAX-loaded
    // and already-in-DOM cases), then populate the reference preview.
    $(document).one(
      "shown.bs.modal",
      contentGeneratorModalSelector,
      function () {
        populateReferenceInModal(
          $(contentGeneratorModalSelector),
          asset.url,
          asset.type
        );
      }
    );

    // Fancybox sits above Bootstrap modals. Close it before showing the
    // generator, otherwise the modal opens successfully but remains hidden
    // behind the active lightbox and the click appears to do nothing.
    if (
      openedFromFancybox &&
      $.fancybox &&
      typeof $.fancybox.close === "function"
    ) {
      $.fancybox.close(true);
    }

    openContentGeneratorModal(existingParams, $btn, "");
  }
}

// ── Global capture-phase intercept ──
// Must use capture:true to intercept BEFORE the event reaches the parent
// <a class="image-wrapper"> where Fancybox has its own click handler.
// stopPropagation here prevents Fancybox; the modal is opened directly.
document.addEventListener(
  "click",
  function (event) {
    const btn = event.target.closest(".btn-use-as-reference");
    if (!btn) return;

    event.preventDefault();
    event.stopPropagation();

    handleUseAsReferenceClick($(btn));
  },
  true
);

// ── "Use as reference" button delegation (bubble phase, kept for safety) ──
$(document).on(
  "click.growtypeChatReferenceAsset",
  ".btn-use-as-reference",
  function (e) {
    // If the capture-phase listener above already handled this click,
    // event.defaultPrevented will be true and we skip the duplicate work.
    if (e.isDefaultPrevented()) return;
    e.preventDefault();
    e.stopPropagation();

    handleUseAsReferenceClick($(this));
  }
);

// ── Remove reference asset button ──
$(document).on(
  "click.growtypeChatReferenceAsset",
  ".btn-close-reference-asset",
  function (e) {
    e.preventDefault();
    e.stopPropagation();
    var modal = $(this).closest(contentGeneratorModalSelector);
    modal.find(".content-generator-reference-asset").empty();
    modal.removeData("referenceAssetUrl");
    modal.removeData("referenceAssetType");
  }
);

// ── Render the reference asset preview in the modal ──
function showReferenceAssetPreview(modal, assetUrl, assetType) {
  var $refDiv = modal.find(".content-generator-reference-asset");
  $refDiv.empty();

  var html = '<div class="reference-asset-preview">';

  if (assetType === "video") {
    // Use first frame as the reference image instead of the video player
    html += '<span class="reference-asset-label">Reference Video</span>';
    html +=
      '<img src="" class="reference-preview-image reference-preview-video-frame" data-video-src="' +
      assetUrl +
      '">';
  } else if (assetType === "audio") {
    html += '<span class="reference-asset-label">Reference Audio</span>';
    html +=
      '<audio src="' +
      assetUrl +
      '" controls class="reference-preview-audio"></audio>';
  } else {
    html += '<span class="reference-asset-label">Reference Image</span>';
    html += '<img src="' + assetUrl + '" class="reference-preview-image">';
  }

  html +=
    '<button type="button" class="btn-close-reference-asset btn-close btn-sm" aria-label="Remove reference"></button>';
  html += "</div>";

  $refDiv.html(html);

  // For video references, capture the first frame as a static image
  if (assetType === "video") {
    captureVideoFirstFrame(
      $refDiv.find(".reference-preview-video-frame"),
      assetUrl
    );
  }
}

// ── Capture the first frame of a video and set it as the img src ──
function captureVideoFirstFrame($img, videoUrl) {
  var video = document.createElement("video");
  video.crossOrigin = "anonymous";
  video.muted = true;
  video.preload = "metadata";
  video.src = videoUrl;

  var frameCaptured = false;

  function cleanup() {
    video.pause();
    video.removeAttribute("src");
    video.load();
    video.remove();
  }

  function captureFrame() {
    if (frameCaptured) return;
    frameCaptured = true;

    // Guard against zero dimensions (video metadata not yet available)
    if (!video.videoWidth || !video.videoHeight) {
      cleanup();
      return;
    }

    var canvas = document.createElement("canvas");
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    var ctx = canvas.getContext("2d");
    ctx.drawImage(video, 0, 0);

    try {
      $img.attr("src", canvas.toDataURL("image/jpeg"));
    } catch (e) {
      // Canvas tainted by cross-origin video without CORS headers —
      // fall back to the video itself as the poster source
      $img.attr("src", "");
    }

    cleanup();
  }

  video.addEventListener("loadeddata", function () {
    if (video.currentTime === 0) {
      // Already at the first frame, capture directly
      captureFrame();
    } else {
      // Seek to the first frame
      video.currentTime = 0;
    }
  });

  video.addEventListener("seeked", function () {
    captureFrame();
  });

  // Handle load failures (404, network error, unsupported format, etc.)
  video.addEventListener("error", function () {
    if (!frameCaptured) {
      frameCaptured = true;
      cleanup();
    }
  });
}
